import { useQuery } from '@tanstack/react-query';
import { debounce } from 'lodash';
import { fetcher } from '../libs';

type Education = {
  name: string;
  educationIssuerClassId: string;
};

const fetchEductions = debounce(async (searchName?: string) => {
  return fetcher<Education[]>(
    `/education-issuers/search/class?name=${searchName}`
  );
}, 300);

export default function useSearchEducationQuery(searchName?: string) {
  return useQuery(
    ['educations', 'search', searchName],
    async () => {
      return fetchEductions(searchName);
    },
    {
      enabled: Boolean(searchName)
    }
  );
}
